module.exports = __webpack_public_path__ + "static/media/kultura-w-sieci-contrast.0dea5a13.svg";